export enum NumericComparator {
  Equals = 'NumericEquals',
  GreaterThan = 'NumericGreaterThan',
  GreaterThanOrEqual = 'NumericGreatThanOrEqual',
  LessThan = 'NumericLessThan',
  LessThanOrEqual = 'NumericLessThanOrEqual',
}

export enum StringComparator {
  Contains = 'Contains',
  MatchesRegex = 'MatchesRegex',
  Equals = 'StringEquals',
  GreaterThan = 'StringGreaterThan',
  GreaterThanOrEqual = 'StringGreaterThanOrEqual',
  LessThan = 'StringLessThan',
  LessThanOrEqual = 'StringLessThanOrEqual',
}

export enum BooleanComparator {
  Equals = 'BooleanEquals',
  DoesNotEqual = 'DoesNotEqual',
}

export enum DateComparator {
  Exactly = 'DateExactly',
  After = 'DateAfter',
  OnOrAfter = 'DateOnOrAfter',
  Before = 'DateBefore',
  OnOrBefore = 'DateOnOrBefore',
}

export type ComparatorType =
  | NumericComparator
  | StringComparator
  | BooleanComparator
  | DateComparator;
